export const SCHOOL_DISTRICT_STATES = ['Ohio', 'Pennsylvania'];
